export default __webpack_public_path__ + "static/media/hht1_ep16_minisitcom_03.2555191c.png";